export const gridLineOption = (showGridlines) => ({
  gridLineDashStyle: 'dash',
  gridLineColor: '#E1E5EB',
  gridLineWidth: showGridlines ? 1 : 0,
});

export const stackingOption = (isStacked) => ({
  stacking: isStacked ? 'normal' : undefined,
});

export const showZoomButtonsEvent = (showZoomButtons, callbacks) => ({
  afterSetExtremes: (event) => {
    const { max, min, dataMax, dataMin } = event;
    showZoomButtons(min > dataMin || max < dataMax);
    callbacks?.forEach((cb) => cb(event));
  },
});

export const zooming = {
  type: 'x',
  resetButton: {
    theme: {
      fill: '#fff',
      stroke: '#E1E5EB',
      r: 4,
      color: '#363D54',
      states: {
        hover: {
          fill: '#EDF0F5',
        },
      },
    },
  },
};

export const navigatorZoomEvent = {
  afterSetExtremes(e) {
    const { min, max, dataMin, dataMax } = e;
    if (min === undefined || max === undefined) return;
    const isZoomed = min > dataMin || max < dataMax;
    const currentlyEnabled = !!this.chart.options?.navigator?.enabled;
    if (isZoomed === currentlyEnabled) return;
    const { chart } = this;

    chart.update(
      {
        navigator: { enabled: isZoomed },
      },
      false
    );

    chart.series[0].points.forEach((point) => {
      point.update(
        {
          marker: {
            enabled: true,
          },
        },
        false
      );
    });

    chart.redraw();
  },
};

export const darkTooltipMainConfig = {
  backgroundColor: 'rgba(33, 37, 49, 0.95)',
  borderWidth: 0,
  borderRadius: 10,
  padding: 14,
  shared: true,
  style: {
    color: 'white',
    fontSize: '14px',
  },
  valueDecimals: 2,
  useHTML: true,
  outside: true,
};
